import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export function useDeleteSOP(
  sopId: string,
  onSuccess?: () => void,
  onError?: (err: Error) => void
) {
  const url = `/v2/orm/sop/delete/${sopId}`;

  const request = new Request(url, {
    method: 'DELETE',
  });

  return useAuthenticatedMutation<null, null>(request, {
    onSuccessInvalidationKeys: [['sop'], ['sop-alarm-types']],
    onSuccess,
    onError,
  });
}

export default useDeleteSOP;
